import { FC, ReactNode, ComponentProps, ComponentPropsWithoutRef } from 'react'
import { SWRResponse } from 'swr'
import { BuyModal } from '@reservoir0x/reservoir-kit-ui'
import { Button } from 'components/primitives'
import { CSS } from '@stitches/react'

type Props = {
  tokenId?: string
  collectionId?: string
  orderId?: string
  buttonCss?: CSS
  buttonProps?: ComponentProps<typeof Button>
  buttonChildren?: ReactNode
  mutate?: SWRResponse['mutate']
  openState?: ComponentPropsWithoutRef<typeof BuyModal>['openState']
}

// PARKED: trading execution is paused during the Alchemy migration.
const BuyNow: FC<Props> = () => {
  // HIDDEN during the browse-only relaunch: native trading is parked, so these
  // controls render nothing. Buying happens via the OpenSeaButton outbound link.
  // To restore, render <TradePausedButton .../> again in the component body below.
  return null
}

export default BuyNow
